export const userPreferences = {
  toasts: {
    errorGetUserPreferencesTitle: 'Eroare',
    errorGetUserPreferencesMessage: 'Încărcarea preferințelor a eșuat',
    errorUpdateUserPreferencesTitle: 'Eroare',
    errorUpdateUserPreferencesMessage: 'Salvarea preferințelor a eșuat'
  }
}
